export enum BuilderCatalogClass {
  STATUTE_IDENTITY = -1,
  DATE_RANGE = -2,
  CATEGORICAL = -3,
  BOOLEAN_FLAG = -4,
}
